import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { SponsorBanner } from '@synergy/models';

import { SPONSOR_BANNER_DELETED } from '../../store/sponsor-banner-actions';
import {
    SPONSOR_BANNER_LIST_ERROR,
    SPONSOR_BANNER_LIST_FETCH,
    SPONSOR_BANNER_LIST_RECEIVE,
} from './sponsor-banner-list-actions';

export interface SponsorBannerListReducerState {
    items: PaginatedResponse<SponsorBanner>;
    requesting: boolean;
}

const initialSponsorBannerListReducerState: SponsorBannerListReducerState = {
    items: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const sponsorBannerListReducer = (
    state: SponsorBannerListReducerState = initialSponsorBannerListReducerState,
    action: AnyAction
): SponsorBannerListReducerState => {
    switch (action.type) {
        case SPONSOR_BANNER_LIST_FETCH: {
            return {
                ...state,
                requesting: true,
            };
        }

        case SPONSOR_BANNER_LIST_RECEIVE: {
            return {
                ...state,
                requesting: false,
                items: action['sponsorBanner'],
            };
        }

        case SPONSOR_BANNER_LIST_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        case SPONSOR_BANNER_DELETED: {
            return {
                ...state,
                items: {
                    ...state.items,
                    items: state.items.items.filter(item => item.id !== action['id']),
                    total: state.items.total - 1,
                },
            };
        }

        default: {
            return state;
        }
    }
};
